export const LEFT_SIDEBAR_KEY = 'sidebar_collapsed'
export const RIGHT_SIDEBAR_KEY = 'doctor_right_sidebar_collapsed'
export const SIDEBAR_SYNC_EVENT = 'qamqor:sidebar-sync'

export function setSidebarCollapsedState(key, collapsed) {
  localStorage.setItem(key, String(collapsed))

  window.dispatchEvent(new CustomEvent(SIDEBAR_SYNC_EVENT, {
    detail: {
      key,
      collapsed
    }
  }))
}
